export const loginMixin = {
    mounted() {
        if (this.Cookies.get("LID") && !window.localStorage.getItem("token")) {
            this.loginByLID(this.Cookies.get("LID"));
        }
    },
    methods: {
        loginByLID(uid) {
            this.axios({
                method: "post",
                url: "/japi/user/login/namepwd/",
                data: { uid },
            }).then((res) => {
                if (res.data.code == 200) {
                    this.loading = false;
                    console.log("登录成功======");
                    console.log(res);
                    //判断浏览器是否支持 localStorage 这个属性
                    if (!window.localStorage) {
                        alert("您的浏览器不支持localstorage");
                        return false;
                    } else {
                        // 将用户名存储到window.localStorage
                        this.token = res.data.data.userToken
                        window.localStorage.setItem("username", res.data.data.userName);
                        window.localStorage.setItem("token", res.data.data.userToken);
                        console.log(res.data.data.userName);
                        console.log(res.data.data.userToken);

                        this.dialogVisibleLogin = false; //弹窗消失
                        this.isLogin = true; //登录 个人中心显示

                        this.setCnkiCookie(res.data.data);
                        // let {radioTree,treeId} =  this.$route.query
                        // if(radioTree && treeId){
                        //   this.$router.push('/legislateKnowledgeBase?radioTree='+ radioTree + '&treeId='+treeId);
                        // }else{
                        //   this.$router.push("/index");
                        //   // this.$router.push("/refresh")
                        // }
                        this.getCheckFun(); //是否有立法知识库的权限
                    }
                } else {
                    this.loading = false;
                    this.$message({
                        message: res.data.msg,
                        type: "warning",
                        duration: 3000,
                    });
                }
            });
        },
        setCnkiCookie(obj) {
            //实现统一登录的cookie设置
            if (obj.LID) {
                let c_m_LinID =
                    "LinID=" +
                    obj.LID +
                    "&ot=" +
                    encodeURIComponent(dateformat(new Date(), "MM/dd/yyyy hh:mm:ss"));
                setParentCookie("c_m_LinID", c_m_LinID);
                setParentCookie("Ecp_LoginStuts", JSON.stringify(obj.userinfo));
                //获取clientID
                setParentCookie("Ecp_ClientId", obj.Ecp_ClientId);
                setParentCookie("LID", obj.LID);
            }
        },
        clearCnkiCookie() { },
        //是否有立法知识库的权限
        getCheckFun() {
            this.axios({
                method: "get",
                url: "/japi/user/is_has_permission/",
                params: {
                    perm_codename_list: JSON.stringify(["can_check_files"]),
                },
            }).then((res) => {
                console.log("权限返回======");
                console.log(res);
                if (res.data.code == 200 || res.data.code == 403) {
                    console.log("权限返回成功======");
                    //判断浏览器是否支持 localStorage 这个属性
                    if (!window.localStorage) {
                        alert("您的浏览器不支持localstorage");
                        return false;
                    } else {
                        this.can_check_files = res.data.data[0].can_check_files;
                        //存储到window.localStorage
                        window.localStorage.setItem(
                            "can_check_files",
                            res.data.data[0].can_check_files
                        );
                        this.$router.push("/index");
                    }
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: "warning",
                        duration: 3000,
                    });
                }
            });
        },
    },
}